import { Feature } from '@yandex/ymaps3-types/packages/clusterer';

/**
 * Смещает координаты точек с одинаковыми координатами
 * чтобы они отображались рядом друг с другом на карте
 * @param features - массив точек для обработки
 * @param offsetDistance - расстояние смещения в градусах (по умолчанию 0.0001, примерно 10 метров)
 */
export function offsetDuplicateCoordinates<T extends Feature>(
  features: T[],
  offsetDistance = 0.0001
): T[] {
  const coordinateGroups = new Map<string, T[]>();

  // Группируем точки по координатам
  features.forEach((feature) => {
    const [lng, lat] = feature.geometry.coordinates;
    const key = `${lng.toFixed(6)},${lat.toFixed(6)}`;

    if (!coordinateGroups.has(key)) {
      coordinateGroups.set(key, []);
    }
    coordinateGroups.get(key)?.push(feature);
  });

  const result: T[] = [];

  coordinateGroups.forEach((group) => {
    if (group.length === 1) {
      // Если точка одна, оставляем как есть
      result.push(group[0]);
    } else {
      // Если точек несколько, смещаем их по кругу
      group.forEach((feature, index) => {
        const [lng, lat] = feature.geometry.coordinates;

        // Вычисляем угол для равномерного распределения по кругу
        const angle = (index * 2 * Math.PI) / group.length;

        // Вычисляем смещение
        const offsetLng = Math.cos(angle) * offsetDistance;
        const offsetLat = Math.sin(angle) * offsetDistance;

        // Создаем новую точку со смещенными координатами
        const offsetFeature: T = {
          ...feature,
          geometry: {
            ...feature.geometry,
            coordinates: [lng + offsetLng, lat + offsetLat]
          }
        };

        result.push(offsetFeature);
      });
    }
  });

  return result;
}
